<template>
  <div class="dem-dev-dados-nf">
    <!-- <div class="cabecalho">
      <-- MONTA O CABECALHO DA TELA --
      <App-Demanda-Editar-Cabecalho
      :cpntDemanda="cpntDemanda"
      :cpntDemandaId="cpntDemandaId"
      :cpntDemandaRefId="cpntDemandaRefId"
      :cpntCampos="cpntPagina === 'frete' ? [ 'numeracao', 'contato', 'editar' ] : [ 'numeracao', 'contato', 'valores', 'editar' ]"

      :cpntIdCon="cpntIdCon"
      :cpntIdConNome="cpntIdConNome"
      :cpntIdConCnpjCpf="cpntIdConCnpjCpf"
      :cpntIdConEmpresa="cpntIdConEmpresa"
      :cpntIdConPessoa="cpntIdConPessoa"
      :cpntIdConStatus="cpntIdConStatus"

      :cpntCreatedAt="cpntCreatedAt"

      :cpntDemandaTotal="cpntDemandaTotal"
      ></App-Demanda-Editar-Cabecalho>
    </div> -->

    <div class="campos" :class="cpntPagina === 'frete' ? 'ocultar-campos' : ''">
      <App-Demanda-Editar-Produtos-Documento
      :cpntDemanda="cpntDemanda"
      :cpntDemandaId="cpntDemandaId"
      :cpntDemandaTotal="cpntDemandaTotal"
      :cpntDemStatus="'devolucao'"
      :cpntDemandaFlag="'resumo'"

      :cpntIdConCnpjCpf="''"
      :cpntIdConPessoa="cpntIdConPessoa"
      :cpntPDocNFEmitida="false"
      :cpntPDocDocs="cpntPDocDocs"
      :cpntPDocCCe="null"
      :cpntPDocTp="cpntPDocTp"
      :cpntPDocNatOpe="''"
      :cpntPDocLocalDespacho="''"
      :cpntPDocEstadoEmbarque="''"
      :cpntPDocCidadeEmbarque="''"

      :cpntPDocTpOptions="cpntPDocTpOptions"
      :cpntPDocFiscal="cpntPDocFiscal"
      :cpntDemData="cpntDemData"
      :cpntPDocOpe="cpntPDocOpe"
      :cpntPDocFin="cpntPDocFin"
      :cpntPDocRefChave="cpntPDocRefChave"
      :cpntPDocIndPres="cpntPDocIndPres"
      :cpntPDocIntermediador="cpntPDocIntermediador"
      :cpntPDocFreTp="cpntPDocFreTp"
      :cpntPDocFrePlacaUf="cpntPDocFrePlacaUf"
      :cpntPDocFrePlaca="cpntPDocFrePlaca"
      :cpntPDocFreVolumes="cpntPDocFreVolumes"
      :cpntPDocRetPrevA="cpntPDocRetPrevA"
      :cpntPDocDataHoraSaiEnt="cpntPDocDataHoraSaiEnt"
      :cpntPDocTransportadora="cpntPDocTransportadora"
      :cpntPDocAcoes="cpntPDocAcoes"
      :cpntPDocDesconto="cpntPDocDesconto"

      :cpntPDocManualChaveAcesso="''"
      :cpntPDocManualDataEmissao="''"
      :cpntPDocManualNumero="''"
      :cpntPDocManualSerie="''"
      :cpntPDocManualFrete="''"
      :cpntPDocManualSeguro="''"
      :cpntPDocManualDesconto="''"
      :cpntPDocManualOda="''"
      ref='documento'
      ></App-Demanda-Editar-Produtos-Documento>
    </div>
  </div>
</template>

<style scoped>
  .dem-dev-dados-nf {
    max-width: 700px;
    margin: 0px auto;
  }
  .dem-dev-dados-nf > .campos {
    /* padding-top: 15px; */
  }
</style>

<style> 
  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc {
    width: 700px !important;
    min-width: 700px !important;
    max-width: 700px !important;
    margin: 0px auto;
    margin-bottom: 20px;
  }
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .p_doc_fre_tp {
    margin-top: -20px;
  }
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .p_doc_nat_ope,
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .p_doc_ope,
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .p_doc_fin,
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .j_p_doc_ref_ca,
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .campos > .p_doc_ind_pres,
  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .p_doc_ret_prev_a,
  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .p_doc_dh_sai_ent,
  .dem-dev-dados-nf > .campos.ocultar-campos > .dem-edi-pro-doc > .botoes {
    display: none !important;
  }

  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_val_frete {
    width: 100px;
    margin-right: 10px;
  }
  /* .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_fre_placa_uf {
    width: calc(100% - 100px - 10px);
  }
  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > div.mostrar-placa-transporte > .dem-edi-pro-doc--p_doc_fre_placa_uf {
    width: calc(100% - 20px - 200px);
  } */
/* .dem-dev-dados-nf > .campos > .dem-edi-pro-doc {
  border: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;

  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}
  .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos {
    margin: 0px !important;
    padding: 0px !important;
  }
    .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > div {
      vertical-align: top !important;
    }
    .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .p_doc_ope {
      padding: 10px;
      border-radius: 5px;
      width: calc((100% / 3) - (15px / 3));
      padding-top: 20px;
      border: 1px solid #c6c4c4;
      border-bottom: 0px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
    .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .p_doc_nat_ope {
      padding: 10px;
      border-radius: 5px;
      width: calc((100% / 3) - (15px / 3));
      padding-top: 20px;
      border: 1px solid #c6c4c4;
      border-top: 0px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }

    .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .p_doc_fin {
      margin-top: 5px;
      padding: 10px;
      border-radius: 5px;
      width: calc((100% / 3) - (15px / 3));
      padding-top: 20px;
      border: 1px solid #c6c4c4;
      border-bottom: 0px;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }

    .dem-dev-dados-nf > .campos > .dem-edi-pro-doc > .campos > .j_p_doc_ref_ca {
      padding: 10px;
      border-radius: 5px;
      width: calc((100% / 3) - (15px / 3));
      padding-top: 20px;
      border: 1px solid #c6c4c4;
      border-top: 0px;
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    } */
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaRefId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntPagina: {
        required: true
      },
      
      cpntDemData: {
        required: true
      },
      cpntIdCon: {
        required: true,
        type: String
      },
      cpntIdConNome: {
        required: true,
        type: String
      },
      cpntIdConCnpjCpf: {
        required: true,
        type: String
      },
      cpntIdConEmpresa: {
        required: true,
        type: String
      },
      cpntIdConPessoa: {
        required: true,
        type: String
      },
      cpntIdConStatus: {
        required: true,
        type: String
      },
      cpntCreatedAt: {
        required: true,
        type: String
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocDocs: {
        required: true
      },
      cpntPDocCCe: {
        required: true
      },
      cpntPDocFiscal: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntPDocTpOptions: {
        required: true
      },
      cpntPDocOpe: {
        required: true
      },
      cpntPDocNatOpe: {
        required: true
      },
      cpntPDocFin: {
        required: true
      },
      cpntPDocRefChave: {
        required: true
      },
      cpntPDocIndPres: {
        required: true
      },
      cpntPDocIntermediador: {
        required: true
      },
      cpntPDocFreTp: {
        required: true
      },
      cpntPDocFrePlacaUf: {
        required: true
      },
      cpntPDocFrePlaca: {
        required: true
      },
      cpntPDocFreVolumes: {
        required: true
      },
      cpntPDocRetPrevA: {
        required: true
      },
      cpntPDocDataHoraSaiEnt: {
        required: true
      },
      cpntPDocTransportadora: {
        required: true
      },
      cpntPDocAcoes: {
        required: true
      },
      cpntPDocDesconto: {
        required: true
      },

      cpntDemDevAtualizarDadosDemanda: {
        required: true
      },
      cpntDemDevSetarStatusGeral: {
        required: true
      }
    },
    components: {
      'App-Demanda-Editar-Cabecalho': () => import('@/components/demanda/Editar/Cabecalho/Demanda-Editar-Cabecalho.vue'),
      'App-Demanda-Editar-Produtos-Documento': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Documento.vue')
    },
    data: function () {
      return {
        time: ''
      }
    },
    mounted: function () {
      if (this.cpntPagina === 'doc_emitir') {
        this.demDevDocAtualizarNaturezaOperacao()
      } else {
        setTimeout(() => {
          this.$refs.documento.campos.p_doc_fre_tp.valueIni = '-1'
        }, 300)
      }
    },
    methods: {
      demDevDocPegarValorCampo: function (indexF) {
        // INICIA A VARIAVEL
        var vetor = {}

        // INICIA A VARIAVEL DA CHAVE
        var chave = this.$refs.documento.campos[indexF].apiEnv
        var indexK = this.$refs.documento.campos[indexF].keyValue

        // SETA O VALOR RECEBIDO NO CAMPO
        vetor[chave] = JSON.parse(JSON.stringify(this.$refs.documento.campos[indexF].value))

        // CONVERTE O VALOR RECEBIDO
        if ([ 'string', 'number' ].indexOf(typeof vetor[chave]) === -1) {
          vetor[chave] = vetor[chave][indexK]
        }

        // RETORNA O VALOR MONTADO
        return vetor
      },
      demDevDocSalvar: function (callback, vetor = null) {
        if (vetor === null) {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.$refs.documento.campos, { disabled: false }).then((_vetor) => { this.demDevDocSalvar(callback, _vetor) })
        } else {
          // PEGA O NOME DA CHAVE
          var chave = Object.keys(vetor)

          // PEGA O VALOR DA CHAVE INFORMADA
          chave = chave.length >= 1 ? chave[0] : null

          // VERIFICA SE TEM VALOR PARA ATUALIZAR
          if ([ '', null, undefined ].indexOf(chave) !== -1) {
            this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, callback)
          } else if (chave === 'p_doc_fre_vol') {
            // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
            delete vetor[chave]

            // MANDA ATUALIZAR OS DADOS DA DEMANDA
            this.demDevDocSalvar(callback, vetor)
          } else {
            // INICIA A VARIAVEL DE ROTA
            var router = ''
            var method = 'PUT'

            // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
            var formData = {}

            // SETA O VALOR DO CAMPO QUE DEVE ATUALIZAR
            formData[chave] = vetor[chave]

            // VERIFICA O CAMPO QUE DEVE ATUALIZAR
            switch (this.cpntDemanda + '__' + chave) {
              case 'dev_cliente__p_doc_fre_tp':
                router = '/demanda/dem-dev-cliente/p-doc-fre-tp'
                break
              case 'dev_fornecedor__p_doc_fre_tp':
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-tp'
                break

              case 'dev_cliente__p_doc_fre_id':
                router = '/demanda/dem-dev-cliente/p-doc-fre-id'
                break
              case 'dev_fornecedor__p_doc_fre_id':
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-id'
                break

              case 'dev_cliente__p_doc_fre_placa':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demDevDocPegarValorCampo('p_doc_fre_placa_uf'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-dev-cliente/p-doc-fre-placa'
                break
              case 'dev_fornecedor__p_doc_fre_placa':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demDevDocPegarValorCampo('p_doc_fre_placa_uf'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-placa'
                break

              case 'dev_cliente__p_doc_fre_placa_uf':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demDevDocPegarValorCampo('p_doc_fre_placa'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-dev-cliente/p-doc-fre-placa'
                break
              case 'dev_fornecedor__p_doc_fre_placa_uf':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demDevDocPegarValorCampo('p_doc_fre_placa'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-placa'
                break                
            }

            // SETA A ROTA QUE DEVE CHAMAR
            if (this.cpntDemanda === 'dev_cliente') {
              formData = { lot: [ Object.assign(formData, { dem_dev_cliente: this.cpntDemandaId }) ] }
            } else if (this.cpntDemanda === 'dev_fornecedor') {
              formData = { lot: [ Object.assign(formData, { dem_dev_fornecedor: this.cpntDemandaId }) ] }
            }

            // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
            delete vetor[chave]

            // VERIFICA SE TEM ROTA PARA SALVAR
            if (router !== '') {
              this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
      
                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.demDevDocTratarValidacao(retorno.message, retorno.code)
                } else {
                  // APRESENTA A MENSAGEM DE SUCESSO
                  this.$store.state.TRATAR_RET_LOT_API(retorno)
      
                  // MANDA ATUALIZAR OS DADOS DA DEMANDA
                  this.demDevDocSalvar(callback, vetor)
                }
              }, this.cpntDemDevSetarStatusGeral, this.demDevDocTratarValidacao)
            }
          }
        }
      },
      demDevDocTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.$refs.documento.campos, this.$refs.documento).then(() => {          
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demDevDocAtualizarNaturezaOperacao: function () {
        if ([ '', null, undefined ].indexOf(this.$refs.documento.campos.p_doc_nat_ope.value) !== -1) {
          this.$refs.documento.demEdiProDocSugerirNatOpe()
        }
      }
    }
  }
</script>
